<template>
  <!-- CRM replica of the client Travelers step (profile-configurable part only):
       the name-spelling disclaimer box. The traveller form fields come from Nezasa
       and carry no profile text, so a representative sample is shown. -->
  <div class="step-travelers">
    <h2 class="step-title">{{ t('checkout_travelers_title', 'Traveler Details') }}</h2>
    <p class="step-subtitle">{{ t('checkout_travelers_subtitle', 'Please provide details for each traveler.') }}</p>

    <div class="pax-card">
      <span class="pax-name">{{ t('checkout_traveler', 'Traveler') }} 1</span>
      <div class="pax-fields">
        <span class="pax-field">{{ t('checkout_firstname', 'First Name') }}</span>
        <span class="pax-field">{{ t('checkout_lastname', 'Last Name') }}</span>
        <span class="pax-field">{{ t('checkout_dob', 'Date of Birth') }}</span>
        <span class="pax-field">{{ t('checkout_nationality', 'Nationality') }}</span>
      </div>
    </div>

    <!-- Name-spelling disclaimer (name_disclaimer box) -->
    <div v-if="showNameDisclaimer" class="name-disclaimer">
      <h3 class="nd-heading" v-if="nameHeading">{{ nameHeading }}</h3>
      <div class="nd-text" v-if="nameTextHtml" v-html="nameTextHtml"></div>
      <label class="checkbox-label">
        <span class="toggle" :style="{ '--toggle-on': brandColor }">
          <input type="checkbox" />
          <span class="toggle-slider"></span>
        </span>
        <span>{{ nameConfirm || t('boomerang_name_confirm', 'Ich habe die Hinweise zur Schreibweise der Namen zur Kenntnis genommen.') }}</span>
      </label>
    </div>

    <div class="step-actions">
      <button class="checkout-btn checkout-btn--secondary">{{ t('checkout_back', 'Back') }}</button>
      <button class="checkout-btn checkout-btn--primary" :style="{ backgroundColor: brandColor }">{{ t('checkout_next', 'Next') }}</button>
    </div>
  </div>
</template>

<script>
import previewLang from './previewLang';

export default {
  name: 'TravelersPreview',
  mixins: [previewLang],
  props: {
    texts: { type: Object, default: () => ({}) },
    rich: { type: Object, default: () => ({}) },
    lang: { type: String, default: 'de' },
    brandColor: { type: String, default: '#1a73e8' },
    boxVisibility: { type: Object, default: () => ({}) }
  },
  computed: {
    // name_disclaimer defaults OFF (matches global default / profile).
    showNameDisclaimer() { return this.boxVisibility.name_disclaimer === true || this.boxVisibility.name_disclaimer === 1; },
    nameHeading() { return (this.texts && this.texts.checkout_name_heading) || this.t('boomerang_name_heading', "Spelling of all travelers' names"); },
    nameConfirm() { return (this.texts && this.texts.checkout_name_confirm) || ''; },
    // Mirrors the client fallback chain: profile rich text, else the locale's
    // boomerang_name_text paragraph (StepTravelerDetails.nameDisclaimerText).
    nameTextHtml() { return (this.rich && this.rich.checkout_name_text) || this.t('boomerang_name_text', ''); }
  }
};
</script>

<style scoped>
.step-title { font-size: 20px; font-weight: 700; margin: 0 0 6px; }
.step-subtitle { font-size: 13px; color: #666; margin: 0 0 24px; }

.pax-card { border: 1px solid #e8e8e8; border-radius: 8px; padding: 14px 16px; margin: 0 0 20px; }
.pax-name { font-size: 14px; font-weight: 600; color: #333; display: block; margin-bottom: 10px; }
.pax-fields { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; }
.pax-field { font-size: 12px; color: #999; border: 1px dashed #e0e0e0; border-radius: 6px; padding: 8px 10px; }

.name-disclaimer { border: 1px solid #e8e8e8; border-radius: 8px; padding: 16px; margin: 0 0 20px; }
.nd-heading { font-size: 15px; font-weight: 600; margin: 0 0 8px; }
.nd-text { font-size: 13px; color: #555; margin: 0 0 12px; }

.checkbox-label { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; line-height: 1.4; margin-top: 8px; }
.toggle { position: relative; display: inline-block; width: 38px; height: 22px; flex-shrink: 0; }
.toggle input { opacity: 0; width: 0; height: 0; position: absolute; }
.toggle-slider { position: absolute; inset: 0; background-color: #ccc; border-radius: 22px; }
.toggle-slider::before { content: ''; position: absolute; height: 16px; width: 16px; left: 3px; top: 3px; background-color: #fff; border-radius: 50%; box-shadow: 0 1px 3px rgba(0,0,0,0.25); }

.step-actions { margin-top: 28px; display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.checkout-btn { padding: 10px 28px; border: none; border-radius: 4px; font-size: 14px; font-weight: 600; }
.checkout-btn--primary { color: #fff; }
.checkout-btn--secondary { background: #f0f0f0; color: #333; }
.nd-text :deep(p) { margin: 0 0 6px; }
</style>
